export const FILE_BROWSER = [
  {
    name: 'conf',
    lastModifiedTime: '2018-04-09 11:20:51',
    size: 4096,
    directory: true,
    path: 'folder/subfolder1/conf',
  },
  {
    name: 'entando_logo.jpg',
    lastModifiedTime: '2018-04-09 11:20:51',
    size: 12194,
    directory: false,
    path: 'folder/subfolder1/entando_logo.jpg',
  },
];

export const FILE_BROWSER_ROOT_FOLDER = [
  {
    name: 'public',
    lastModifiedTime: null,
    size: null,
    directory: true,
    path: 'public',
    protectedFolder: false,
  },
  {
    name: 'protected',
    lastModifiedTime: null,
    size: null,
    directory: true,
    path: 'protected',
    protectedFolder: true,
  },
];

export const FILE_BROWSER_FILE = {
  protectedFolder: false,
  path: 'folder/subfolder/filename',
  filename: 'filename',
  base64: 'base64',
};

export const FILE_BROWSER_FOLDER = {
  protectedFolder: false,
  path: 'folder/subfolder',
};
